import React from 'react';
import { Link, useMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Dropdown from 'Douleutaras/components/Dropdown/Dropdown';
import DropdownJobItemContainer from 'Douleutaras/layout/partials/DropdownJobItemContainer';
import DropdownJobItem from 'Douleutaras/components/Dropdown/DropdownJobItem';
import SkeletonLoader from 'Douleutaras/components/Loaders/SkeletonLoader';
import { buildUrl, getAbsoluteUrl, VALID_URLS } from 'Douleutaras/utilities/url-builder';
import { URLS } from 'Douleutaras/constants/urls';
import classNames from 'classnames';
import { Job, JSONApiDataObject } from 'Douleutaras/types';

import './JobsDropdown.scss';

interface JobsDropdownProps {
  isOpen: boolean;
  activeJobs: JSONApiDataObject<Job>;
  onToggle(open: boolean): void;
  onHeaderClick(e: React.MouseEvent<HTMLAnchorElement>): void;
}

export const JobsDropdown: React.FC<JobsDropdownProps> = ({
                                                                    isOpen,
                                                                    onToggle,
                                                                    onHeaderClick,
                                                                    activeJobs
                                                                  }) => {
  const { t } = useTranslation();
  // @ts-ignore
  const active = activeJobs.meta?.statusCounts.active;
  const isProDashboard = useMatch({
    path: getAbsoluteUrl('CLIENT_DASHBOARD.INDEX'),
    end: true,
    caseSensitive: true
  });

  return (
    <Dropdown
      title={t('My Jobs')}
      isOpen={isOpen}
      callback={onToggle}
      header={
        <header styleName="default-header-job-item">
          <a
            styleName={classNames({
              'default-header-job-item__link': true,
              active: isOpen || isProDashboard
            })}
            onClick={onHeaderClick}
            href="#"
          >
            <span styleName="default-header-job-item__icon">
              <i className="dashicon dashicon-header-jobs" />
              { active > 0 && <span styleName="default-header-job-item__count">{ active > 9 ? '9+' : active }</span> }
            </span>
            <span styleName="default-header-job-item__title">{t('My jobs')}</span>
          </a>
        </header>
      }
      footer={
        <footer styleName="user-dropdown-footer">
          <div styleName="user-dropdown-footer-item">
            <Link
              to={URLS.CLIENT_DASHBOARD.INDEX}
              styleName="user-dropdown-footer-item__link "
              data-tracking="customer-header-see-all-jobs"
              onClick={() => onToggle(false)}
            >
              <span styleName="user-dropdown-footer-item__title">
                {t('See all jobs')}
              </span>
            </Link>
          </div>
        </footer>
      }
    >
      {  // @ts-ignore
        activeJobs.data?.map(
        (item, i) =>
          i <= 4 && (
            <DropdownJobItemContainer
              href={buildUrl(VALID_URLS.CLIENT_DASHBOARD_JOB, item.id)}
              jobId={item.id}
              categoryId={item.relationships.category.data.id}
              key={`#${item.id}`}
              callback={onToggle}
            />
          )
      )}

      {  // @ts-ignore
        !activeJobs?.ids?.length && activeJobs.loading &&
        new Array(3).fill(undefined)
          .map((_, index) => (
          <DropdownJobItem
            title={
              <SkeletonLoader
                type="line"
                width={170}
                height={20}
                inLine
              />
            }
            icon={
              <SkeletonLoader
                type="D-shape"
                width={40}
                height={47}
              />
            }
            jobId={
              <SkeletonLoader
                type="line"
                width={75}
                height={20}
                inLine
              />
            }
            callback={() => true}
            href="#"
            key={`jobs_loader_${index}`}
          />
        ))}
    </Dropdown>
  );
};

export default JobsDropdown;
